import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Box, Grid, Pagination, CircularProgress } from "@mui/material";
// import CustomTable from "components/CustomTable";
import { useRecoilState } from "recoil";
import { selectedButtonState, totalCountState } from "../../recoil/index.ts";
import { getInspModels } from "../../services/inspModelService.js";
import { deleteModel } from "../../services/inspModelService.js";
import { useNavigate } from "react-router-dom";
import MouseClickList from "../MouseClickList.tsx";

export default function ModelTable({
  setCount,
  setOpenModal,
  receivedData,
  setReceivedData,
  total,
  currentPage,
  setPage,
  setSelectedModelInfo,
}) {
  const [selectedButton, setSelectedButton] = useRecoilState(selectedButtonState);
  const [totalItems, setTotalItems] = useRecoilState(totalCountState);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedButton("모델");
  }, []);

  const columns = [
    { field: "id", headerName: "No.", width: 100 },
    { field: "name", headerName: "Model Name", width: 500 },
    {
      field: "description",
      headerName: "Description",
      width: 200,
    },
  ];

  const handleEdit = () => {
    navigate(`/insp-model/${selectedModelId}`);
  };

  const handleDelete = async (row) => {
    try {
      if (window.confirm("정말 삭제하시겠습니까?")) {
        await deleteModel(selectedModelId);
        const response = await getInspModels();
        setReceivedData(response.data.contents);
        setCount(response.data.total_count);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDetailClick = async (params) => {
    try {
      setOpenModal(true);
      setSelectedModelInfo(params.row);
    } catch (error) {
      console.error(error);
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    const selectedModelId = event.currentTarget.getAttribute("data-id");
    setAnchorEl(event.currentTarget);
    setOpen(true);
    setSelectedModelId(Number(selectedModelId));
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Grid container sx={{ mt: 3 }}>
            <DataGrid
              hideFooter
              hideFooterPagination
              disableColumnMenu
              disableColumnSorting
              rows={receivedData}
              columns={columns}
              getRowId={(row) => row.id}
              slotProps={{
                row: {
                  onContextMenu: handleContextMenu,
                  style: { cursor: "context-menu" },
                },
              }}
              onRowClick={handleDetailClick}
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-filler": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-virtualScrollerContent": {
                  backgroundColor: "white",
                },
                "& .MuiDataGrid-cell": {
                  cursor: "pointer",
                  backgroundColor: "var(--unselected-row-bg)",
                  color: "var(--dg-color)",
                },
              }}
            />

            <MouseClickList
              anchorEl={anchorEl}
              open={open}
              category="train"
              // existModuleIds={existModuleIds}
              onClose={handleClose}
              onEdit={handleEdit}
              onDelete={handleDelete}
              // onModuleDelete={handleModuleDelete}
            />
            {/* {isModalOpen && (
                  <TrainModal
                    open={isModalOpen}
                    onClose={handleCloseModal}
                    state={state}
                    selectTrain={selectedTrain}
                  />
                )} */}
          </Grid>
          <Pagination
            count={Math.ceil(total / 10)}
            page={currentPage}
            onChange={(_, value) => setPage(value)}
            color="primary"
            size="medium"
            sx={{ mt: 2, display: "flex", justifyContent: "center" }}
          />
        </Box>
      )}
    </>
  );
}
